<div class="login-background"></div>
<div class="login-background-overlay"></div>
<div class="login-logo">
    <div class="h-100">
        <div class="login-compas-logo"></div>
    </div>
</div>
<cmps-client-logo [login]="true"></cmps-client-logo>
<div
    class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-align-items-center cmps-auth-login--container1"
>
    <div
        class="cmps-cdk-pos-relative cmps-cdk-p-1dot5 cmps-auth-login--container2"
        *ngIf="!_authorizationCodeGrantType && !_tokenFragment"
    >
        <div
            class="cmps-cdk-pos-absolute cmps-cdk-pos-top-0 cmps-cdk-pos-right-0"
        >
            <cmps-i18n-switcher></cmps-i18n-switcher>
        </div>
        <form
            id="cmpsAuthLogin"
            name="cmpsAuthLogin"
            [formGroup]="_formGroup"
        >
            <div class="h5 text-white cmps-cdk-text-center">
                {{ _i18n._130_LOGIN | translate | uppercase }}
            </div>
            <div
                class="alert alert-info cmps-cdk-text-center"
                role="alert"
                *ngIf="_noticeText"
            >
                {{ _noticeText }}
            </div>
            <div [class.cmps-cdk-d-none]="_step !== _Step.AUTH_METHODS">
                <label
                    class="sr-only"
                    for="username"
                >
                    {{ _i18n._72_USERNAME | translate }}
                </label>
                <input
                    id="username"
                    type="text"
                    class="cmps-form-input"
                    name="username"
                    autocomplete="username"
                    required
                    [placeholder]="_i18n._72_USERNAME | translate"
                    formControlName="username"
                />
                <div
                    class="alert alert-warning cmps-cdk-mt-1 cmps-cdk-mb-0"
                    role="alert"
                    *ngIf="
                        _formGroup?.controls?.username?.errors?.required &&
                        _formGroup?.controls?.username?.dirty
                    "
                >
                    {{
                        _i18n._640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_
                            | translate
                                : {
                                      field_label:
                                          _i18n._72_USERNAME | translate
                                  }
                    }}
                </div>
                <div
                    class="alert alert-warning cmps-cdk-mt-1 cmps-cdk-mb-0"
                    role="alert"
                    *ngIf="_serverError"
                >
                    {{ _serverError | translate }}
                </div>
                <div
                    class="cmps-cdk-d-flex cmps-cdk-justify-content-flex-end cmps-cdk-mt-1"
                >
                    <button
                        type="submit"
                        cmpsButton
                        [disabled]="_formGroup.disabled"
                        (click)="_onDetermineAuthMethodsClick()"
                        *ngIf="_step === _Step.AUTH_METHODS"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._9632_NEXT | translate
                        }}</span>
                    </button>
                </div>
            </div>
            <div [class.cmps-cdk-d-none]="_step !== _Step.AUTH_PWD">
                <label
                    class="sr-only"
                    for="password"
                >
                    {{ _i18n._55_PASSWORD | translate }}
                </label>
                <input
                    id="password"
                    type="password"
                    class="cmps-form-input"
                    name="password"
                    autocomplete="current-password"
                    required
                    [placeholder]="_i18n._55_PASSWORD | translate"
                    formControlName="password"
                />
                <div
                    class="alert alert-warning cmps-cdk-mt-1 cmps-cdk-mb-0"
                    role="alert"
                    *ngIf="
                        _formGroup?.controls?.password?.errors?.required &&
                        _formGroup?.controls?.password?.dirty
                    "
                >
                    {{
                        _i18n._640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_
                            | translate
                                : {
                                      field_label:
                                          _i18n._72_USERNAME | translate
                                  }
                    }}
                </div>
                <div
                    class="alert alert-warning cmps-cdk-mt-1 cmps-cdk-mb-0"
                    role="alert"
                    *ngIf="_serverError"
                >
                    {{ _serverError | translate }}
                </div>
                <div
                    class="justify-content-between cmps-cdk-d-flex cmps-cdk-mt-1"
                >
                    <button
                        type="button"
                        class="cmps-auth-login--button1"
                        cmpsButton
                        [disabled]="_formGroup.disabled"
                        (click)="_onForgotPwdClick()"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._129_FORGOT_PASSWORD | translate
                        }}</span>
                    </button>
                    <button
                        type="submit"
                        cmpsButton
                        [disabled]="_formGroup.disabled"
                        (click)="_onPwdAuthClick()"
                        *ngIf="_step === _Step.AUTH_PWD"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._130_LOGIN | translate
                        }}</span>
                    </button>
                </div>
            </div>
            <div [class.cmps-cdk-d-none]="_step !== _Step.AUTH_SAML2">
                <div class="cmps-cdk-d-flex cmps-cdk-justify-content-center">
                    <button
                        type="button"
                        cmpsButton
                        name="saml2"
                        (click)="_onSaml2AuthClick()"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._11035_LOGIN_USING_SSO | translate
                        }}</span>
                    </button>
                </div>
                <div
                    class="alert alert-warning cmps-cdk-mt-1 cmps-cdk-mb-0"
                    role="alert"
                    *ngIf="_serverError"
                >
                    {{ _serverError | translate }}
                </div>
            </div>
        </form>
    </div>
</div>
<div
    class="fixed-bottom cmps-auth-login--container3 cmps-cdk-pos-absolute"
    role="contentinfo"
>
    <div
        class="cmps-cdk-d-flex justify-content-between cmps-cdk-align-items-center cmps-cdk-px-1 cmps-cdk-py-0dot5"
    >
        <div class="h6 text-white cmps-cdk-text-center cmps-cdk-m-0">
            &copy; 2005-2025 Orbit Group Partners Inc.
        </div>
        <div class="cmps-cdk-text-center">
            <img
                src="assets/orbitLogoWhite.png"
                alt
                role="presentation"
            />
        </div>
    </div>
</div>
